import React, { memo } from 'react';
import { PlaceIcon } from './CustomIcons';
import { makeStyles } from '@mui/styles';
import { Grid, Typography } from '@mui/material';

const useStyles = makeStyles((theme) => ({
    container: {
        position: "absolute",
        // top:'50%',
        userSelect: "none",
        transform: "translate(-50%, -50%)",
        cursor: 'pointer'
    },
    underline: {
        textDecoration: 'underline',
        cursor: 'pointer'
    },
    markerInfo: {
        position: "absolute",
        top: -90,
        left: -60,
        width: 220,
        padding: theme.spacing(2),
        backgroundColor: theme.palette.common.white,
    },
    place: {
        marginTop: -50
    }
}));

function CustomGoogleMarker(props) {
    const classes = useStyles();
    const { info, onSelect, markerSelected, onClick, myPlace } = props;
    const contact_info = info && info.contact_info ? info.contact_info : null;
    var description = info && info.description ? info.description : '';
    var phone = null;
    var email = null;

    if (contact_info && contact_info.length > 0) {
        for (var i = 0; i < contact_info.length; i++) {
            if (contact_info[i].type === 'EMAIL') {
                email = contact_info[i].value
            }
            else if (contact_info[i].type === 'PHONE') {
                phone = contact_info[i].value
            }
        }
    }
    description = phone ? description + ' • ' + phone : description;
    description = email ? description + ' • ' + email : description;

    return (
        <div className={classes.container}>
            {myPlace && <PlaceIcon className={classes.place} />}
            {!myPlace && onClick && <PlaceIcon onClick={() => onClick(info.id)} />}
            {!myPlace && !onClick && <PlaceIcon />}
            {markerSelected && markerSelected === info.id && <div className={classes.markerInfo}>
                <Grid xs={12} item container direction='row' onClick={onSelect}>
                    <Grid xs={12} item>
                        <Typography variant='body2'>{info.title}</Typography>
                        <Typography variant='description'>{description}</Typography>
                    </Grid>
                    {/* <Grid xs={3} item container justify='flex-end'>
                        <Typography onClick={onSelect} variant='body2' color="secondary" className={classes.underline}>Select</Typography>
                    </Grid> */}
                </Grid>
            </div>}
        </div>
    );
}
export default memo(CustomGoogleMarker)